import { Box, Grid, List, Stack, styled } from '@mui/material';
import { FieldValues, FormProvider, SubmitHandler, useFormContext } from 'react-hook-form';
import { WsButton, WsDrawer, WsSelect } from 'wisestep-base';

import { WsAccordion } from '../../../../components/filters/components';
import BasicSearchForm from '../../types/IBasicSearchForm';
import ICVLibraryAdvanceSearch from '../types/ICVLibraryAdvanceSearch';

interface AdvanceFilterProps {
  open: boolean;
  onClose: () => void;
  performSearch: (values: BasicSearchForm & ICVLibraryAdvanceSearch) => void;
}

const DrawerFooter = styled(Grid)(() => ({
  display: 'flex',
  alignItems: 'center',
  position: 'fixed',
  bottom: 1,
  left: 2,
  right: 2,
  justifyContent: 'flex-end',
}));

const AdvanceFilter = ({ open, onClose, performSearch }: AdvanceFilterProps) => {
  const methods = useFormContext();
  const { handleSubmit, reset } = methods;
  return (
    <FormProvider {...methods}>
      <WsDrawer
        title="Advanced Filters"
        open={open}
        onClose={() => onClose()}
        size="medium"
        headerSize="medium"
      >
        <Box
          component="form"
          role="presentation"
          onSubmit={handleSubmit(performSearch as SubmitHandler<FieldValues>)}
          onReset={() => reset()}
        >
          <Box pb={7}>
            <List>
              <WsAccordion title="Stem Phrases">
                <WsSelect
                  name="stemPhrases"
                  selectArray={[
                    {
                      label: 'Yes',
                      value: '1',
                    },
                    {
                      label: 'No',
                      value: '0',
                    },
                  ]}
                  placeholder="Select"
                />
              </WsAccordion>

              <WsAccordion title="Search Name Only">
                <WsSelect
                  name="searchNameOnly"
                  selectArray={[
                    {
                      label: 'Yes',
                      value: '1',
                    },
                    {
                      label: 'No',
                      value: '0',
                    },
                  ]}
                  placeholder="Select"
                />
              </WsAccordion>

              <WsAccordion title="Willing to Relocate">
                <WsSelect
                  name="relocation"
                  selectArray={[
                    {
                      label: 'Yes',
                      value: '1',
                    },
                    {
                      label: 'No',
                      value: '0',
                    },
                  ]}
                  placeholder="Select"
                />
              </WsAccordion>

              <WsAccordion title="Search Salary">
                <WsSelect
                  name="salary"
                  selectArray={[
                    {
                      label: '£1 – 10,000',
                      value: '1',
                    },
                    {
                      label: '£10,001 - £15,000',
                      value: '2',
                    },
                    {
                      label: '£15,001 – £20,000',
                      value: '3',
                    },
                    {
                      label: '£20,001 - £25,000',
                      value: '4',
                    },
                    {
                      label: '£25,001 - £30,000',
                      value: '5',
                    },
                    {
                      label: '£30,001 - £40,000',
                      value: '6',
                    },
                    {
                      label: '£40,001 - £60,000',
                      value: '7',
                    },
                    {
                      label: '£60,001 - £80,000',
                      value: '8',
                    },
                    {
                      label: '£80,001 - £100,000',
                      value: '9',
                    },
                    {
                      label: '£100,001 - £120,000',
                      value: '10',
                    },
                    {
                      label: '£120,000 +',
                      value: '11',
                    },
                  ]}
                  placeholder="Select"
                />
              </WsAccordion>
              <WsAccordion title="Industry">
                <WsSelect
                  name="industry"
                  selectArray={[
                    { label: 'Accountancy', value: 'Accountancy' },
                    { label: 'Administration', value: 'Administration' },
                    { label: 'Advertising', value: 'Advertising' },
                    { label: 'Aerospace/Aviation/Defence', value: 'Aerospace/Aviation/Defence' },
                    { label: 'Agriculture', value: 'Agriculture' },
                    { label: 'Architecture', value: 'Architecture' },
                    { label: 'Art/Design/Graphics', value: 'Art/Design/Graphics' },
                    { label: 'Automotive', value: 'Automotives' },
                    { label: 'Banking', value: 'Banking' },
                    { label: 'Biotechnology', value: 'Biotechnology' },
                    {
                      label: 'Catering &amp; Food Services',
                      value: 'Catering &amp; Food Services',
                    },
                    {
                      label: 'Charity/Voluntary/Non Profit',
                      value: 'Charity/Voluntary/Non Profit',
                    },
                    { label: 'Construction', value: 'Construction' },
                    { label: 'Consultancy', value: 'Consultancy' },
                    { label: 'Counseling', value: 'Counseling' },
                    { label: 'Customer service', value: 'Customer service' },
                    { label: 'Dental', value: 'Dental' },
                    { label: 'Driving', value: 'Driving' },
                    { label: 'Education', value: 'Education' },
                    { label: 'Electrical', value: 'Electrical' },
                    { label: 'Electronic', value: 'Electronic' },
                    { label: 'Emergency', value: 'Emergency' },
                    { label: 'Engineering', value: 'Engineering' },
                    { label: 'Entertainment', value: 'Entertainment' },
                    { label: 'Fashion', value: 'Fashion' },
                    { label: 'Financial', value: 'Financial' },
                    { label: 'Graduate', value: 'Graduate' },
                    { label: 'Health &amp; Safety', value: 'Health &amp; Safety' },
                    { label: 'Health medical', value: 'Health medical' },
                    { label: 'Home worker', value: 'Home worker' },
                    { label: 'Hotel/Hospitality', value: 'Hotel/Hospitality' },
                    {
                      label: 'Human-resources &amp; Employment',
                      value: 'Human-resources &amp; Employment',
                    },
                    { label: 'IT/Internet/Technical', value: 'IT/Internet/Technical' },
                    { label: 'Import export', value: 'Import export' },
                    { label: 'Industrial', value: 'Industrial' },
                    { label: 'Insurance', value: 'Insurance' },
                    { label: 'Journalism', value: 'Journalism' },
                    { label: 'Legal', value: 'Legal' },
                    { label: 'Leisure', value: 'Leisure' },
                    { label: 'Management &amp; Executive', value: 'Management &amp; Executive' },
                    { label: 'Manufacturing', value: 'Manufacturing' },
                    { label: 'Marketing &amp; PR', value: 'Marketing &amp; PR' },
                    { label: 'Mechanical', value: 'Mechanical' },
                    { label: 'Media/Creative/Digital', value: 'Media/Creative/Digital' },
                    { label: 'Nursing', value: 'Nursing' },
                    { label: 'Oil &amp; Gas/Energy', value: 'Oil &amp; Gas/Energy' },
                    { label: 'Other', value: 'Other' },
                    { label: 'Packaging', value: 'Packaging' },
                    { label: 'Pharmaceutical', value: 'Pharmaceutical' },
                    { label: 'Photography', value: 'Photography' },
                    { label: 'Printing', value: 'Printing' },
                    { label: 'Property', value: 'Property' },
                    { label: 'Public sector', value: 'Public sector' },
                    { label: 'Publishing', value: 'Publishing' },
                    { label: 'Purchasing/Procurement', value: 'Purchasing/Procurement' },
                    { label: 'Recruitment', value: 'Recruitment' },
                    { label: 'Retail', value: 'Retail' },
                    { label: 'Sales', value: 'Sales' },
                    { label: 'Scientific', value: 'Scientific' },
                    { label: 'Secretarial &amp; PA', value: 'Secretarial &amp; PA' },
                    { label: 'Security', value: 'Security' },
                    { label: 'Social services', value: 'Social services' },
                    { label: 'Teaching', value: 'Teaching' },
                    { label: 'Telecomms', value: 'Telecomms' },
                    { label: 'Textiles', value: 'Textiles' },
                    {
                      label: 'Trades - Skilled &amp; Unskilled',
                      value: 'Trades - Skilled &amp; Unskilled',
                    },
                    { label: 'Transport &amp; Logistics', value: 'Transport &amp; Logistics' },
                    { label: 'Travel &amp; Tourism', value: 'Travel &amp; Tourism' },
                    {
                      label: 'Utilities &amp; Installation',
                      value: 'Utilities &amp; Installation',
                    },
                    { label: 'Warehouse', value: 'Warehouse' },
                    { label: 'Waste management', value: 'Waste management' },
                  ]}
                  label="Select"
                />
              </WsAccordion>

              <WsAccordion title="Language">
                <WsSelect
                  name="language"
                  selectArray={[
                    { value: '1', label: 'Afrikaans' },
                    { value: '2', label: 'Albanian' },
                    { value: '3', label: 'Arabic' },
                    { value: '4', label: 'Basque' },
                    { value: '5', label: 'Bulgarian' },
                    { value: '6', label: 'Byelorussian' },
                    { value: '7', label: 'Catalan' },
                    { value: '8', label: 'Croatian' },
                    { value: '9', label: 'Czech' },
                    { value: '10', label: 'Danish' },
                    { value: '11', label: 'Dutch' },
                    { value: '13', label: 'Esperanto' },
                    { value: '14', label: 'Estonian' },
                    { value: '15', label: 'Faroese' },
                    { value: '16', label: 'Finnish' },
                    { value: '17', label: 'French' },
                    { value: '18', label: 'Galician' },
                    { value: '19', label: 'German' },
                    { value: '20', label: 'Greek' },
                    { value: '21', label: 'Hebrew' },
                    { value: '22', label: 'Hungarian' },
                    { value: '23', label: 'Icelandic' },
                    { value: '24', label: 'Irish' },
                    { value: '25', label: 'Italian' },
                    { value: '26', label: 'Japanese' },
                    { value: '27', label: 'Korean' },
                    { value: '28', label: 'Lapp' },
                    { value: '29', label: 'Latvian' },
                    { value: '30', label: 'Lithuanian' },
                    { value: '31', label: 'Mandarin' },
                    { value: '32', label: 'Macedonian' },
                    { value: '33', label: 'Maltese' },
                    { value: '34', label: 'Norwegian' },
                    { value: '35', label: 'Polish' },
                    { value: '36', label: 'Portuguese' },
                    { value: '37', label: 'Romanian' },
                    { value: '38', label: 'Russian' },
                    { value: '39', label: 'Serbian' },
                    { value: '41', label: 'Slovak' },
                    { value: '42', label: 'Slovenian' },
                    { value: '43', label: 'Spanish' },
                    { value: '44', label: 'Swedish' },
                    { value: '45', label: 'Turkish' },
                    { value: '46', label: 'Ukrainian' },
                    { value: '47', label: 'Welsh' },
                    { value: '95', label: 'Thai' },
                    { value: '96', label: 'Hindi' },
                    { value: '97', label: 'Punjabi' },
                    { value: '98', label: 'Persian' },
                  ]}
                  placeholder="Select"
                />
              </WsAccordion>

              <WsAccordion title="Category">
                <WsSelect
                  name="tempPerm"
                  selectArray={[
                    {
                      label: 'Permanent',
                      value: 'perm',
                    },
                    {
                      label: 'Contract',
                      value: 'cont',
                    },
                    {
                      label: 'Temporary',
                      value: 'temp',
                    },
                    {
                      label: 'Part Time',
                      value: 'part',
                    },
                  ]}
                  placeholder="Select"
                />
              </WsAccordion>

              <WsAccordion title="Minimum Matching">
                <WsSelect
                  name="minMatch"
                  selectArray={[
                    {
                      label: 'Any',
                      value: '0',
                    },
                    {
                      label: '25%',
                      value: '25',
                    },
                    {
                      label: '50%',
                      value: '50',
                    },
                    {
                      label: '75%',
                      value: '75',
                    },
                  ]}
                  placeholder="Select"
                />
              </WsAccordion>
            </List>
          </Box>
          <DrawerFooter>
            <Stack p={1} spacing={2} direction="row">
              <WsButton variant="outlined" size="large" type="reset">
                Reset
              </WsButton>
              <WsButton variant="contained" size="large" type="submit">
                Apply
              </WsButton>
            </Stack>
          </DrawerFooter>
        </Box>
      </WsDrawer>
    </FormProvider>
  );
};

export default AdvanceFilter;
